import { TableColumn, TableData } from '@billy/design-system'
import { View } from '@react-pdf/renderer'
import { ReactElement } from 'react'

import { Currency } from '../../../../../../../../../../types/currency'
import { LocaleIdentifier } from '../../../../../../../../../../types/localeIdentifier'
import { SalesReportPdfTableContent } from './elements/SalesReportPdfTableContent'
import { SalesReportPdfTableFooter } from './elements/SalesReportPdfTableFooter'
import { SalesReportPdfTableHeaderRow } from './elements/SalesReportPdfTableHeaderRow'
import { pdfStyles } from './utils/pdfStyles'

interface SalesReportPdfTableProps<T extends TableData> {
  currency: Currency
  footerLabel: string
  locale: LocaleIdentifier
  tableColumns: TableColumn<T>[]
  tableData: T[]
  totalSales: string
}

export const SalesReportPdfTable = <T extends TableData>({
  currency,
  footerLabel,
  locale,
  tableColumns,
  tableData,
  totalSales,
}: SalesReportPdfTableProps<T>): ReactElement => {
  return (
    <View style={pdfStyles.table}>
      <SalesReportPdfTableHeaderRow tableColumns={tableColumns} />
      <SalesReportPdfTableContent
        currency={currency}
        locale={locale}
        tableColumns={tableColumns}
        tableData={tableData}
      />
      <SalesReportPdfTableFooter footerLabel={footerLabel} totalSales={totalSales} />
    </View>
  )
}
